'use client';

import Typography from '@enlighten/design-system/dist/Typography';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { NavigationItem } from '@/constants/navigation';

export default function SubMenuItem({ title, linkProps }: Omit<NavigationItem['subMenuList'][number], 'subTitle'>) {
	const pathname = usePathname();

	return (
		<Link {...linkProps} role="link">
			<Typography sx={{ textDecoration: pathname === linkProps.href ? 'underline' : undefined }}>{title}</Typography>
		</Link>
	);
}
